import { render, staticRenderFns } from "./MobileHomeNews.vue?vue&type=template&id=30e3eace&scoped=true&"
import script from "./MobileHomeNews.vue?vue&type=script&lang=ts&"
export * from "./MobileHomeNews.vue?vue&type=script&lang=ts&"
import style0 from "./MobileHomeNews.vue?vue&type=style&index=0&id=30e3eace&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e3eace",
  null
  
)

export default component.exports